<template>
  <div class="scroll-box enable-scroll">
    <div class="box">
      <MainHalfTitle text="新增測試者"></MainHalfTitle>
      <div class="row">
        <InputBox text="測試者全名" placeholder="請輸入測試者全名" margin_top="short" @getValue="getNameValue"></InputBox>
      </div>
      <div class="row">
        <SelectBox text="性別" :options="sex_option" margin_top="short" @getValue="getSexValue"></SelectBox>
      </div>
      <div class="row">
        <SelectBox text="出生年份" :options="birth_year_option" :defaultValue="birth_year" margin_top="short"
          @getValue="getBirthYearValue"></SelectBox>
      </div>
      <div class="row">
        <InputBox v-if="has_mobile" text="手提電話號碼" hideInput="true" margin_top="short" :value="show_mobile"></InputBox>
        <InputBox v-if="input_mobile" text="手提電話號碼" placeholder="請輸入手提電話號碼" type="number" margin_top="short" @getValue="getMobileValue"></InputBox>
      </div>
      <div class="row">
        <SelectBox text="教育程度" :options="education_level_option" margin_top="short" @getValue="getEducationLevelValue">
        </SelectBox>
      </div>
      <div class="row">
        <SelectBox text="居住地區" :options="district_level1_option" margin_top="short" @getValue="getDistrictLevel1Value">
        </SelectBox>
      </div>
      <div class="row">
        <SelectBox :options="district_level2_option" :defaultValue="district_level2" margin_top="short"
          @getValue="getDistrictLevel2Value">
        </SelectBox>
      </div>
      <div class="row" v-if="show_district_level3">
        <SelectBox :options="district_level3_option" :defaultValue="district_level3" margin_top="short"
          @getValue="getDistrictLevel3Value">
        </SelectBox>
      </div>
      <ConfirmButton text="新增測試者" position="relative" @click="addUser"></ConfirmButton>
      <!-- <ConfirmButton class="button" text="新增測試者" position="relative" @click="addUser"></ConfirmButton> -->
    </div>

    <AlertModal :element="this" css_class="alert-modal-short" show_confirm="true" confirm_text="確定"
      :confirm_fun="confirmFun" text_align="text-center"></AlertModal>
  </div>
</template>

<script>
import MainHalfTitle from "@/components/common/MainHalfTitle";
import ConfirmButton from "@/components/common/ConfirmButton";
import common from "@/common";
import InputBox from "@/components/common/InputBox";
import SelectBox from "@/components/common/SelectBox";
import AlertModal from "@/components/common/AlertModal";
export default {
  name: "HomeAddUser",
  components: {
    AlertModal,
    ConfirmButton,
    SelectBox,
    InputBox,
    // ConfirmButton,
    MainHalfTitle,
  },
  emits: ['addUser', 'mounted', 'unmounted'],
  data() {
    return {
      common: common,
      has_mobile: false,
      input_mobile: false,
      show_district_level3: false,
      show_mobile: '',

      name: '',
      sex: 0,
      mobile: '',
      birth_year: 0,
      education_level: 0,
      districts: [],
      district_level1: 0,
      district_level2: 0,
      district_level3: 0,
      sex_option: [
        { id: 0, text: '請選擇' },
        { id: 1, text: '男' },
        { id: 2, text: '女' },
      ],
      birth_year_option: [],
      education_level_option: [
        { id: 0, text: '請選擇' },
        { id: 1, text: '三年或以下教育' },
        { id: 2, text: '三年以上至小學畢業' },
        { id: 3, text: '中學程度' },
        { id: 4, text: '大專或大學以上' },
      ],
      district_level1_option: [{ id: 0, name: '請選擇' }],
      district_level2_option: [{ id: 0, name: '請選擇' }],
      district_level3_option: [{ id: 0, name: '請選擇' }],
    }
  },
  props: {
    districtList: { type: Array }
  },
  created() {
    if (this.districtList.length !== 0) {
      this.districts = this.districtList;
      this.getDistrictLevel1List();
    }
    this.birth_year = parseInt(new Date().getFullYear() - 50)
  },
  watch: {
    // 每当 districtList 改变时，这个函数就会执行
    districtList: {
      handler(newValue) {
        this.districts = newValue;
        this.getDistrictLevel1List();
      },
      deep: true
    }
  },
  mounted() {
    this.$emit('mounted')
    const currentYear = parseInt(new Date().getFullYear());
    let year = 1900;
    while (year !== currentYear) {
      year += 1;
      this.birth_year_option.unshift({ id: year, text: year })
    }
    this.birth_year_option.unshift({ id: 0, text: '請選擇' })

    common.getStorage('account_mobile').then(mobile => {
      if (mobile) {
        this.mobile = mobile;
        this.show_mobile = common.splitMobile(mobile);
        this.has_mobile = true;
      } else {
        this.input_mobile = true;
      }
    })
  },
  unmounted() {
    this.$emit('unmounted')
  },
  methods: {
    getDistrictLevel1List: function () {
      const districts = this.districts.filter(p => p.level === 1);
      districts.forEach(element => {
        this.district_level1_option.push(element);
      });
    },
    getDistrictLevel2List: function (value) {
      this.district_level2_option = [{ id: 0, name: '請選擇' }];
      const districts = this.districts.filter(p => p.level === 2 && p.parent_id === value);
      districts.forEach(element => {
        this.district_level2_option.push(element);
      });
      this.district_level2 = 0;
    },
    getDistrictLevel3List: function (value) {
      this.district_level3_option = [{ id: 0, name: '請選擇' }];
      const districts = this.districts.filter(p => p.level === 3 && p.parent_id === value);
      districts.forEach(element => {
        this.district_level3_option.push(element);
      });
      this.district_level3 = 0;
    },

    getNameValue: function (value) {
      this.name = value;
    },
    getMobileValue: function (value) {
      this.mobile = value;
    },
    getSexValue: function (value) {
      this.sex = value;
    },
    getBirthYearValue: function (value) {
      this.birth_year = value;
    },
    getEducationLevelValue: function (value) {
      this.education_level = value;
    },
    getDistrictLevel1Value: function (value) {
      this.district_level1 = value;
      this.getDistrictLevel2List(value);
      this.show_district_level3 = false;
      this.district_level3 = 0;
    },
    getDistrictLevel2Value: function (value) {
      this.district_level2 = value;
      if (value === 31) {
        this.show_district_level3 = true;
        this.getDistrictLevel3List(value);
      }
      else {
        this.show_district_level3 = false;
        this.district_level3 = 0;
      }
    },
    getDistrictLevel3Value: function (value) {
      this.district_level3 = value;
    },

    getSexText: function (value) {
      const res = this.sex_option.find(function (item) {
        return item.id == value
      })
      return res.text;
    },
    getEducationLevelText: function (value) {
      const res = this.education_level_option.find(function (item) {
        return item.id == value
      })
      return res.text;
    },
    getAreaDistrictlText: function (level1Value, level2Value, level3Value) {
      const level1 = this.district_level1_option.find(function (item) {
        return item.id == level1Value
      })
      const level2 = this.district_level2_option.find(function (item) {
        return item.id == level2Value
      })
      if (level3Value !== 0) {
        const level3 = this.district_level3_option.find(function (item) {
          return item.id == level3Value
        })
        return level1.name + '-' + level2.name + (level2.remark ? `(${level2.remark})` : '') + '-' + level3.name;
      }
      else {
        return level1.name + '-' + level2.name + (level2.remark ? `(${level2.remark})` : '');
      }
    },
    addUser: function () {
      if (this.name.length === 0) {
        common.showAlert('請輸入測試者全名。');
        return;
      }
      if (this.sex === 0) {
        common.showAlert('請選擇性別。');
        return;
      }
      if (this.birth_year === 0) {
        common.showAlert('請選擇出生年份。');
        return;
      }
      if (!this.has_mobile && this.mobile.length === 0) {
        common.showAlert('請輸入手提電話號碼。');
        return;
      }
      if (this.education_level === 0) {
        common.showAlert('請選擇教育程度。');
        return;
      }
      if (this.district_level1 === 0 || this.district_level2 === 0 || this.show_district_level3 === true && this.district_level3 === 0) {
        common.showAlert('請選擇居住地區。');
        return;
      }

      const content = [
        '測試者全名：' + this.name,
        '性別：' + this.getSexText(this.sex),
        '出生年份：' + this.birth_year,
      ];
      if (this.input_mobile) {
        content.push('手提電話號碼：' + this.mobile);
      }
      content.push('教育程度：' + this.getEducationLevelText(this.education_level));
      content.push('居住地區：' + this.getAreaDistrictlText(this.district_level1, this.district_level2, this.district_level3));

      this.common.config.alertModal.isOpen = true;
      this.common.config.alertModal.title = '請確認測試者資料';
      this.common.config.alertModal.content = content;

      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;
      this.common.config.alertModal.didDismissFun = function () {
        that.common.config.alertModal.isOpen = false;
      }

      // common.showConfirm(
      //     '請確認測試者資料<br>' +
      //     '測試者全名：'+this.name+'<br>'+
      //     '性別：'+this.getSexText(this.sex)+'<br>'+
      //     '出生年份：'+this.birth_year+'<br>'+
      //     '教育程度：'+this.getEducationLevelText(this.education_level)
      // , '新增測試者', function (that) {
      //       that.$emit('addUser', that.name, that.sex, that.birth_year, that.mobile, that.education_level);
      //     }, this)
    },
    confirmFun: function () {
      this.common.config.alertModal.isOpen = false;
      if (this.show_district_level3 !== true) {
        this.$emit('addUser', this.name, this.sex, this.birth_year, this.mobile, this.education_level, this.district_level2);
      }
      else {
        this.$emit('addUser', this.name, this.sex, this.birth_year, this.mobile, this.education_level, this.district_level3);
      }
    }
  }
}
</script>

<style scoped>
.row {
  text-align: center;
  transform: translateX(clamp(-4rem, -6vw, -2rem));
}

@media (max-width: 720px) {
  .row {
    transform: none;
  }
}

.row {
  font-size: var(--ecs-font-md);

  text-align: left;
  /*margin-left: 10vw;*/
  padding: clamp(0.5rem, 1vw, 0.75rem);
  line-height: 1.25;
}

.item {
  width: var(--ecs-label-width);
  display: inline-block;
}

.value {
  display: inline-block;
}

.button {
  margin-top: 6vh;
  --background: #94c43b;
  width: 26%;
  min-height: var(--ecs-button-min-height);
  height: auto;
  white-space: normal;
}
</style>
